import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { StorageService } from './service/shared/storage.service';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { ParametroService } from './service/apoio/parametro.service';
import { filter } from 'rxjs';

const NIVEIS = {
  1: 'Super',
  2: 'Adm Didáticos',
  3: 'Representante',
  4: 'Escola'
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public isLoggedIn = true;
  public user!: string;
  public nivel!: string;

  faBarcode = faBarcode;

  public selectedItem: string | null = null;
  public showSubmenuMap: { [key: string]: boolean } = {};

  constructor(
    private router: Router,
    private storage: StorageService,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Verifique a rota atual e atualize a variável isLoggedIn conforme necessário
      this.isLoggedIn = this.activatedRoute.snapshot.firstChild?.routeConfig?.path !== 'login';
    });
  }

  ngOnInit(): void {
    // this.isLoggedIn = this.storage.isloggedIn();
    this.user = this.storage.getUser();

    if (this.storage.getPermissoes()[0].id_nivel === 1) this.nivel = NIVEIS[1];
    if (this.storage.getPermissoes()[0].id_nivel === 2) this.nivel = NIVEIS[2];
    if (this.storage.getPermissoes()[0].id_nivel === 3) this.nivel = NIVEIS[3];
    if (this.storage.getPermissoes()[0].id_nivel === 4) this.nivel = NIVEIS[4];

    if (!this.isLoggedIn) {
      this.router.navigate(['/login']);
    }
  }

  public toggleSubmenu(item: string) {
    this.showSubmenuMap[item] = !this.showSubmenuMap[item];
  }

  public showSubmenu(item: string): boolean {
    return this.showSubmenuMap[item];
  }

  public logout() {
    this.storage.clean();
    this.isLoggedIn = false;
    this.router.navigate(['/login']);
  }

  public temAcessoMenu(menu: number): boolean {
    return this.storage.temAcessoMenu(menu);
  }
}
